import React, { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useParams, useHistory } from 'react-router-dom';
import Loader from "../components/Loader";
import Spinner from "../components/Spinner";
import Swal from 'sweetalert2';
import { METHODTYPE, DESERVE_STATUS } from '../components/constants';

function CompanyReview() {
    const { idProduct, idUser } = useParams();
    const { getAccessTokenSilently } = useAuth0();
    const serverUrl = process.env.REACT_APP_SERVER_URL;
    const [isLoaded, setIsLoaded] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [productName, setProductName] = useState("");
    const [remarkByCompany, setRemarkByCompany] = useState("");
    const [details, setDetails] = useState("");
    const [price, setPrice] = useState("");
    const [imageUrl, setImageUrl] = useState("");
    const [postUrl, setPostUrl] = useState("");
    const [timeperiode, setTimeperiode] = useState("");
    const [timeperiodeFrom, setTimeperiodeFrom] = useState("");
    const [timeperiodeTo, setTimeperiodeTo] = useState("");
    const [homePage, setHomePage] = useState("");
    const [deserveStatus, setDeserveStatus] = useState("");

    useEffect(() => {
        async function getDeserve() {
            const token = await getAccessTokenSilently();
            localStorage.setItem("AcccessToken", token);

            const response = await fetch(`${serverUrl}/api/deserves/companyReview/${idProduct}/${idUser}`, {
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' }
            });
            const productDeserve = await response.json();
            setProductDeserve(productDeserve);
            setIsLoaded(true);
            setIsRunning(false);
        }

        if (idProduct && idUser) {
            getDeserve();
        } else {
            setIsLoaded(true);
            setIsRunning(false);
        }
    }, []);

    function setProductDeserve(productDeserve) {
        //setId(product.id);
        setProductName(productDeserve.name);
        setRemarkByCompany(productDeserve.remarkByCompany);
        setDetails(productDeserve.details);
        setPrice(productDeserve.price);
        setImageUrl(productDeserve.imageUrl);
        setPostUrl(productDeserve.postUrl);
        setTimeperiode(productDeserve.timeperiode);
        setTimeperiodeFrom(productDeserve.timeperiodeFrom ? new Date(productDeserve.timeperiodeFrom).toISOString().split("T")[0] : "");
        setTimeperiodeTo(productDeserve.timeperiodeTo ? new Date(productDeserve.timeperiodeTo).toISOString().split("T")[0] : "");
        setHomePage(productDeserve.homePage);
        setDeserveStatus(productDeserve.status);
    }
    const getDeserveStatusMessage = (deserveStatus) => {
        switch (deserveStatus) {
            case DESERVE_STATUS.ACCEPTED_BY_ADMIN: return "Bestätigung ist noch ausstehend";
            case DESERVE_STATUS.ACCEPTED_BY_COMPANY: return "Bestätigt";
            case DESERVE_STATUS.REJECTED_BY_COMPANY: return "Abgelehnt";
            default: return "NA"
        }
    }

    const rejectDeserveStatus = async () => {
        updateDeserveStatus(false);
    }

    const approveDeserveStatus = async () => {
        updateDeserveStatus(true);
    }

    const handleInputChange = (event) => {
        setRemarkByCompany(event.target.value);
    }
    const updateDeserveStatus = async (isAccepted) => {
        try {
            const token = await getAccessTokenSilently();
            var bodyRequest = JSON.stringify({
                "isAccepted": isAccepted,
                "remark": remarkByCompany
            });
            const response = await fetch(
                `${serverUrl}/api/deserves/companyReview/${idProduct}/${idUser}`,
                {
                    method: METHODTYPE.PUT,
                    body: bodyRequest,
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            let result = await response.json();

            if (result.isSuccessful) {
                swalWithBootstrapButtons.fire({
                    title: "Gespeichert!",
                    text: "",
                    icon: "success"
                }).then(() => {
                    window.location.reload();
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: result.message,
                    //footer: '<a href="#">Why do I have this issue?</a>'
                });
            }
        } catch (error) {
            swalWithBootstrapButtons.fire({
                title: "Oops...",
                text: error.message,
                icon: "error"
            });
        }
    }

    const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
            confirmButton: "btn btn-outline-warning",
            cancelButton: "btn btn-outline-warning"
        },
        buttonsStyling: false
    });

    return (
        <React.Fragment>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Produktdetails</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section className="content">
                <div className="card card-solid">
                    <Spinner isRunning={isRunning} />

                    {!isLoaded ? <div className="text-center"><Loader /></div> :
                        <div className="container-fluid">
                            <div className="">
                                <div className="form-group">

                                    {/* Alle Felder anzeigen, aber disabled */}
                                    <div className="row">
                                        <div className="col-md-12 text-center mb-3 mt-3">
                                            {imageUrl && (
                                                <img
                                                    src={imageUrl}
                                                    alt={productName || "Produktbild"}
                                                    style={{ maxWidth: "300px", maxHeight: "300px", objectFit: "contain" }}
                                                />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Produktname</label>
                                            <input type="text" className="form-control" value={productName || ""} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Homepage</label>
                                            {homePage ? (
                                                <a
                                                    href={homePage.startsWith("http://") || homePage.startsWith("https://") ? homePage : `https://${homePage}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="form-control disabled text-break h-auto"
                                                    style={{ backgroundColor: "#e9ecef" }}
                                                >
                                                    {homePage}
                                                </a>
                                            ) : (
                                                <input type="text" className="form-control" value="" disabled />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-xs-12">
                                            <label>Benötigte Likes</label>
                                            <input type="number" className="form-control" value={price || ""} disabled />
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <label>Tage</label>
                                            <input type="number" className="form-control" value={timeperiode || ""} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Produktbeschreibung</label>
                                            <textarea className="form-control" value={details || ""} rows={5} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-xs-12">
                                            <label>Startdatum</label>
                                            <input type="date" className="form-control" value={timeperiodeFrom || ""} disabled />
                                        </div>
                                        <div className="col-md-6 col-xs-12">
                                            <label>Enddatum</label>
                                            <input type="date" className="form-control" value={timeperiodeTo || ""} disabled />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>PostUrl</label>
                                            {postUrl ? (
                                                <a
                                                    href={postUrl.startsWith("http://") || postUrl.startsWith("https://") ? postUrl : `https://${postUrl}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="form-control disabled text-break h-auto"
                                                    style={{ backgroundColor: "#e9ecef" }}
                                                >
                                                    {postUrl}
                                                </a>
                                            ) : (
                                                <input type="text" className="form-control" value="" disabled />
                                            )}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Status</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={getDeserveStatusMessage(deserveStatus)}

                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <label>Bemerkung</label>
                                            <input
                                                onChange={handleInputChange}
                                                type="text"
                                                className="form-control"
                                                value={remarkByCompany}
                                                disabled={deserveStatus == DESERVE_STATUS.ACCEPTED_BY_ADMIN ? false : true}
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Do wee need a reason/comment before rejecting? */}
                                {deserveStatus == DESERVE_STATUS.ACCEPTED_BY_ADMIN && (
                                    <div className="row">
                                        <div className="d-flex justify-content-center mb-3">
                                            <button
                                                id={idProduct + "reached"}
                                                className="btn btn-outline-warning col-md-6"
                                                block="true"
                                                onClick={() => {
                                                    swalWithBootstrapButtons.fire({
                                                        title: "Bist Du sicher, dass Du bestätigen möchtest?",
                                                        text: "",
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Ja",
                                                        cancelButtonText: "Nein",
                                                        //reverseButtons: true
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            approveDeserveStatus();
                                                        }
                                                    });
                                                }}
                                            >
                                                Bestätigen
                                            </button>
                                            <button
                                                id={idProduct + "reached"}
                                                className="btn btn-outline-warning col-md-6"
                                                block="true"
                                                onClick={() => {
                                                    swalWithBootstrapButtons.fire({
                                                        title: "Bist Du sicher, dass Du ablehnen möchtest?",
                                                        text: "",
                                                        icon: "question",
                                                        showCancelButton: true,
                                                        confirmButtonText: "Ja",
                                                        cancelButtonText: "Nein",
                                                        //reverseButtons: true
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            rejectDeserveStatus();
                                                        }
                                                    });
                                                }}
                                            >
                                                Ablehnen
                                            </button>
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    }
                </div>
            </section>
        </React.Fragment>
    );
}

export default CompanyReview;
